export const isPastilleActive = (pastille, currentRefinements) => {
    return pastille.attributes.every(({ key, value }) => {
        if (Array.isArray(currentRefinements[key]) && Array.isArray(value)) {
            return value.every(val => currentRefinements[key].includes(val));
        }
        return currentRefinements[key] === value;
    });
};

export default { isPastilleActive };
